(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function playHeroVideos() {
    var videos = document.querySelectorAll('.hero__video');
    videos.forEach(function(video) {
      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function() {
            video.addEventListener('touchstart', function() {
              video.play();
            }, { once: true });
          });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', playHeroVideos);
  } else {
    playHeroVideos();
  }

  window.addEventListener('load', playHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
